import '../app.es6';
import angular from 'angular';

function create () {
  let array = [
    [1, 5],
    [1, 4],
    [1, 3],
    [1, 2],
    [2, 6],
    [2, 5],
    [2, 4],
    [2, 3],
    [2, 2],
    [2, 1],
    [3, 6],
    [3, 5],
    [3, 4],
    [3, 3],
    [3, 2],
    [3, 1],
    [4, 6],
    [4, 5],
    [4, 4],
    [4, 3],
    [4, 2],
    [4, 1],
    [5, 5],
    [5, 4],
    [5, 3],
    [5, 2]
  ];

  return array;
}

angular.module('myApp').factory('ImpactPointConstants', create);



// WEBPACK FOOTER //
// ./app/services/impact-point-constants.es6